/**
 *  @fileOverview Modal module, initalises tooltips for fast facts
 *
 *  @author       Chris Hill
 *
 */

function TooltipModule (tippy, axios) {
  /**
   * @description Initialises tooltip instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Get all fast fact links
     */
    var ulinks = document.querySelectorAll('.toolTip')

    /**
     * Loop through and add click events
     */
    ulinks.forEach((link, index) => {
      /**
       * Only process if there is a data-fact attribute
       */
      if (typeof link.dataset.fact !== 'undefined') {
        let fact = link.dataset.fact
        let url = 'https://www.ecu.edu.au/degrees/shared-content/lookups/fast-fact2?factTitle=' + fact

        tippy(link, {
          trigger: 'click',
          arrow: true,
          content: 'Loading...',
          onHidden (instance) {
            instance.setContent('Loading...')
            instance.state.ajax.canFetch = true
          },
          onShow (instance) {
            // We can monkey-patch the instance's state object with our own state
            if (instance.state.ajax === undefined) {
              instance.state.ajax = {
                isFetching: false,
                canFetch: true
              }
            }

            // Now we will avoid initiating a new request unless the old one
            // finished (`isFetching`).
            // We also only want to initiate a request if the tooltip has been
            // reset back to Loading... (`canFetch`).
            if (instance.state.ajax.isFetching || !instance.state.ajax.canFetch) {
              return
            }

            // Retrieve fast fact info from Funnelback
            axios.get(url)
              .then(response => {
                instance.setContent(response.data.description)
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                instance.state.ajax.isFetching = false
              })
          }
        })
      }
    })
  }
}

module.exports = TooltipModule
